import React from 'react';
import { Table, Empty, Button } from 'antd';


export default function CustomTable(props) {
    return (
        <Table
            bordered={props.bordered === undefined ? false : props.bordered}
            style={{ overflowX: 'auto' }}
            title={() => (
                <div style={{ width: '100%', textAlign: "right" }}>
                    <div className="custom-options">
                        {
                            props.onExportExcel === undefined ? null :
                                <Button ghost
                                    type="success"
                                    icon="file-excel"
                                    onClick={props.onExportExcel}
                                    style={{ color: '#3fb703' }}
                                    loading={props.loadingExcel}
                                >
                                    Excel
                                </Button>
                        }
                        {
                            props.onExportPdf === undefined ? null :
                                <Button ghost
                                    type="danger"
                                    icon="file-pdf"
                                    onClick={props.onExportPdf}
                                    style={{ color: '#ff4d4f' }}
                                    loading={props.loadingPdf}
                                >
                                    Pdf
                                </Button>
                        }
                        {
                            props.onExportPdfRegistrado === undefined ? null :
                                <Button ghost
                                    type="danger"
                                    icon="file-pdf"
                                    onClick={props.onExportPdfRegistrado}
                                    style={{ color: '#ff4d4f' }}
                                    loading={props.loadingPdfRegistrado}
                                >
                                    Pdf - Registrados
                                </Button>
                        }
                        {
                            props.onPrint === undefined ? null :
                                <Button ghost
                                    type="primary"
                                    icon="printer"
                                    onClick={props.onPrint}
                                    style={{ color: '#1890ff' }}
                                    loading={props.loadingPrint}
                                >
                                    Imprimir
                                </Button>
                        }
                        {
                            props.onExportPLE === undefined ? null :
                                <Button
                                    icon="file"
                                    onClick={props.onExportPLE}
                                    style={{ color: '#fffff' }}
                                    loading={props.loadingPLE}
                                >
                                    PLE
                                </Button>
                        }
                        {
                            props.onExportSIRE === undefined ? null :
                                <Button
                                    icon="file"
                                    onClick={props.onExportSIRE}
                                    style={{ color: '#fffff' }}
                                    loading={props.loadingSIRE}
                                >
                                    SIRE
                                </Button>
                        }
                    </div>
                </div>
            )}
            columns={props.columns}
            loading={
                props.pagination.loading ? {
                    tip: "Un momento por favor",
                    size: "large"
                } : false
            }
            size="small"
            rowKey={props.rowKey}
            dataSource={props.pagination.data}
            onChange={(pagination, filters, sorter) => {
                props.onChange({
                    page: pagination.current,
                    order: sorter.order,
                    field: sorter.field
                })
            }}
            locale={{
                emptyText: <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="No se encontraron datos."
                />
            }}
            pagination={{
                total: props.pagination.total,
                current: props.pagination.page,
                pageSize: props.pagination.pageSize,
                showTotal: (total) => `${total} Registro(s) encontrado(s).`
            }}
        />
    );
}